import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
export function Presentation() {
  return <section className="py-12 md:py-16 px-4 relative" data-id="element-166">
      <div className="max-w-3xl mx-auto text-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-20 h-20 mx-auto mb-8 relative" data-id="element-168">
          <div className="absolute inset-0 bg-brand-blue rounded-full blur-[40px] opacity-50" data-id="element-169" />
          <div className="relative w-full h-full glass-card rounded-full flex items-center justify-center border-brand-blue/30" data-id="element-170">
            <Brain className="w-10 h-10 text-brand-blue" data-id="element-171" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6" data-id="element-172">
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-brand-blue" data-id="element-173">
            // AQUÍ ES DONDE EXISTE
          </div>

          <h2 className="text-3xl md:text-5xl font-display font-bold leading-tight" data-id="element-174">
            <span className="text-brand-blue" data-id="element-175">Visiongol</span> no adivina
            resultados.
            <br data-id="element-176" />
            Traduce el ruido en{' '}
            <span className="text-brand-green" data-id="element-177">probabilidad.</span>
          </h2>

          <p className="text-base md:text-lg text-gray-400 leading-relaxed max-w-2xl mx-auto pt-2" data-id="element-178">
            Una capa de decisión construida sobre comportamiento real del
            partido, estructura estadística y señales contextuales en tiempo
            real. Para que ya no interpretes el fútbol desde la emoción — sino
            desde la estructura.
          </p>
        </motion.div>
      </div>
    </section>;
}